import { ArrowRight, BookOpen, CalendarDays, GitBranch, History, Map, Presentation, Settings2 } from 'lucide-react'
import { formatDate } from '../lib/project'
import type { GeneralReferenceRow } from '../types'
import { HelpTooltip } from '../components/HelpTooltip'

type Props = {
  reference: GeneralReferenceRow
  onCanvas: () => void
  onPresentation: () => void
  onEditor: () => void
}

export function ReferenceOverview({ reference, onCanvas, onPresentation, onEditor }: Props) {
  const stepCount = reference.content.phases.reduce((total, phase) => total + phase.steps.filter((step) => step.enabled !== false).length, 0)
  return (
    <main className="workspace reference-overview">
      <div className="page-heading">
        <div><span className="eyebrow">RÉFÉRENCE GÉNÉRALE</span><h1>{reference.content.title}</h1><p>Version {reference.version} · {reference.content.id}</p></div>
        <button className="primary-button" onClick={onEditor} type="button"><Settings2 size={17} /> Préparer une nouvelle version</button>
      </div>

      <section className="reference-summary-card">
        <div><BookOpen size={23} /><span><small>Contenu publié</small><strong>{reference.content.phases.length} phases · {stepCount} étapes</strong></span></div>
        <div><CalendarDays size={23} /><span><small>Date de référence</small><strong>{formatDate(reference.content.effective_date)}</strong></span></div>
        <div><GitBranch size={23} /><span><small>Branches facultatives</small><strong>{reference.content.optional_branches.length}</strong></span></div>
        <div><History size={23} /><span><small>Historique</small><strong>{reference.version} version{reference.version > 1 ? 's' : ''}</strong></span></div>
      </section>

      <section className="reference-boundary"><BookOpen size={20} /><div><strong>Cette référence est indépendante des projets. <HelpTooltip text="Une nouvelle version devient le point de départ des nouveaux projets. Les projets déjà créés conservent leur propre parcours tant qu’Aziz ne décide pas de les adapter." label="Que devient un projet existant ?" align="left" /></strong><span>La modifier ne change aucun projet existant.</span></div></section>

      <section className="reference-tool-grid">
        <button onClick={onCanvas} type="button"><span><Map size={24} /></span><div><strong>Parcours visuel général</strong><p>Plan 2D, Couches 3D ou POV par îlots.</p></div><ArrowRight size={19} /></button>
        <button onClick={onPresentation} type="button"><span><Presentation size={24} /></span><div><strong>Présentation générale</strong><p>Préparer une projection, un PowerPoint ou un PDF sans données de projet.</p></div><ArrowRight size={19} /></button>
        <button onClick={onEditor} type="button"><span><Settings2 size={24} /></span><div><strong>Préparer une nouvelle version</strong><p>Modifier phases, étapes et branche de dérogation, puis publier.</p></div><ArrowRight size={19} /></button>
      </section>
    </main>
  )
}
